import { _ as mt } from "./objectDestructuringEmpty-69c165c0.js";
import "./es.symbol.description-6025a604.js";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.array.map-d821aaf5.js";
import "./es.array.some-0c761b6d.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.object.to-string-f55666a8.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.regexp.to-string-e800d529.js";
import "./es.string.search-d27ec57a.js";
import { s as mn } from "./es.string.trim-6e13db75.js";
import Ee, { useRef as we, useState as Ce, useMemo as Je, useEffect as ge, forwardRef as Be, createContext as Wt, useContext as qt, useCallback as St, createElement as vn, Fragment as hn } from "react";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as ye } from "./getMetrics-953aa4f8.js";
import { _ as le } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.function.bind-b4bdcd4b.js";
import "./es.array.from-fe752fa6.js";
import "./es.function.name-b230e7d4.js";
import "./es.date.to-json-b76d522e.js";
import "./es.date.to-string-6ed49878.js";
import "./es.parse-float-020a2ae0.js";
import "./es.string.iterator-5de8a61e.js";
import { _ as wt } from "./export-cdcbfb2b.js";
import { s as fn } from "./string-trim-14e37ad3.js";
import { a as je } from "./index-5d0f31c6.js";
import { useCustomTranslation as bn } from "@ucl/ucl-translation";
import { c as f } from "./index-8b07dec9.js";
import { createPortal as gn } from "react-dom";
import "./es.object.keys-9d66766f.js";
import "@ucl/shared-component-foundations";
import { getAriaProps as Ue } from "./aria.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import { useSlots as ee } from "./useSlots.js";
import "./createClass-57dcdeea.js";
import { useWindowSize as _n } from "./useWindowSize.js";
import { HelperText as Qe, InputState as De } from "./helperText.js";
import "./es.array.join-c1bca812.js";
import { uniqueId as ze } from "./uniqueId.js";
import u, { css as p } from "styled-components";
import { Image as Ft } from "./image.js";
import { Label as vt } from "./label.js";
import { jsxs as M, jsx as r, Fragment as Bt } from "react/jsx-runtime";
import "./carousel.js";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.link-fd2676c6.js";
import { E as Cn } from "./index-f2264f1e.js";
import { ScreenReaderOnly as wn } from "./screenReaderOnly.js";
import { c as Tn } from "./combineRefs-c9ad2c39.js";
import { useAccessibilityProps as xn } from "./accessibility.js";
import { g as Rt } from "./getElementPosition-8d0dbc61.js";
import { Text as Tt } from "./text.js";
import { _ as Mt } from "./cloneSlots-622cf8c9.js";
import { Button as dt } from "./button.js";
import { Link as _t } from "./link.js";
import "./es.global-this-a7f40ce1.js";
import "./aspectRatio.js";
import "./es.parse-int-d7709701.js";
import { CloseButton as Ht } from "./closeButton.js";
import { Badge as Ct } from "./badge.js";
var yn = fn.start, kn = mn, Kt = kn("trimStart") ? function() {
  return yn(this);
} : "".trimStart, In = wt, Ot = Kt;
In({ target: "String", proto: !0, name: "trimStart", forced: "".trimLeft !== Ot }, {
  trimLeft: Ot
});
var Nn = wt, $t = Kt;
Nn({ target: "String", proto: !0, name: "trimStart", forced: "".trimStart !== $t }, {
  trimStart: $t
});
var Dn = /* @__PURE__ */ u.label.withConfig({
  displayName: "checkboxstyles__Label",
  componentId: "sc-170rztt-0"
})(["&.CheckBox__label{", ";}"], function(t) {
  var e = t.theme, n = e.componentStyles, a = e.components.checkbox;
  return p(a.Label, n);
}), Sn = /* @__PURE__ */ u.div.withConfig({
  displayName: "checkboxstyles__LabelContent",
  componentId: "sc-170rztt-1"
})(["&.CheckBox__label-content{", ";}"], function(t) {
  var e = t.theme.components.checkbox;
  return p(e.LabelContent);
}), Bn = /* @__PURE__ */ u.div.withConfig({
  displayName: "checkboxstyles__Content",
  componentId: "sc-170rztt-2"
})(["&.CheckBox__content{", ";}"], function(t) {
  var e = t.theme.components.checkbox;
  return p(e.Content);
}), Rn = /* @__PURE__ */ u.span.withConfig({
  displayName: "checkboxstyles__CheckboxInputWrapper",
  componentId: "sc-170rztt-3"
})(["&.Checkbox__input-wrapper{", ";}"], function(t) {
  var e = t.theme.components.checkbox;
  return p(e.CheckBoxInputWrapper);
}), Mn = /* @__PURE__ */ u.input.withConfig({
  displayName: "checkboxstyles__CheckboxInput",
  componentId: "sc-170rztt-4"
})(["&.CheckBox{", ";}"], function(t) {
  var e = t.theme.components.checkbox;
  return p(e.CheckboxInput);
}), On = /* @__PURE__ */ u.span.withConfig({
  displayName: "checkboxstyles__CheckmarkContainer",
  componentId: "sc-170rztt-5"
})(["&.CheckBox__checkmark-container{", ";}"], function(t) {
  var e = t.theme.components.checkbox;
  return p(e.CheckmarkContainer);
}), $n = /* @__PURE__ */ u(vt).withConfig({
  displayName: "checkboxstyles__LabelContainer",
  componentId: "sc-170rztt-6"
})(["&.CheckBox__content-container{", ";}"], function(t) {
  var e = t.theme.components.checkbox;
  return p(e.LabelContainer);
}), Pn = /* @__PURE__ */ u.div.withConfig({
  displayName: "checkboxstyles__Media",
  componentId: "sc-170rztt-7"
})(["&.Checkbox__media{", ";}"], function(t) {
  var e = t.theme.components.checkbox;
  return p(e.Media);
}), En = /* @__PURE__ */ u(Ft).withConfig({
  displayName: "checkboxstyles__TileImage",
  componentId: "sc-170rztt-8"
})(["&.Checkbox__image{", ";}"], function(t) {
  var e = t.theme.components.checkbox;
  return p(e.TileImage);
}), An = ["variant", "size", "disabled", "checkboxValue", "error", "helperText", "label", "value", "onChange", "isIntermediate", "id", "infoText", "required", "media", "className"], $e = {
  UNCHECKED: 0,
  INTERMEDIATE: 1,
  CHECKED: 2
}, Ut = function(e) {
  var n = e.variant, a = n === void 0 ? "default" : n, o = e.size, i = o === void 0 ? "small" : o, m = e.disabled, v = m === void 0 ? !1 : m, k = e.checkboxValue, s = k === void 0 ? $e.UNCHECKED : k, g = e.error, y = g === void 0 ? !1 : g, I = e.helperText, b = e.label, E = e.value, C = e.onChange, T = e.isIntermediate, A = e.id, L = e.infoText, D = e.required, h = e.media, j = e.className, K = le(e, An), G = ye({
    label: "Checkbox"
  }), B = A || ze("checkbox_"), z = function(Y) {
    T ? (s++, s = s % 3) : s = s === $e.UNCHECKED ? $e.CHECKED : $e.UNCHECKED, C == null || C(Y, s);
  }, J = function(Y) {
    (Y.code === "Enter" || Y.code === "Space") && (Y.preventDefault(), z(Y));
  }, re = T && s === $e.INTERMEDIATE;
  return /* @__PURE__ */ M(Dn, Object.assign({
    className: f(["CheckBox__label", "CheckBox__label--" + i, "CheckBox__label--" + a, {
      "CheckBox__label--disabled": v
    }, j])
  }, G, {
    children: [/* @__PURE__ */ M(Sn, {
      className: f(["CheckBox__label-content", "CheckBox__label-content--" + a]),
      children: [/* @__PURE__ */ M(Rn, {
        className: f(["Checkbox__input-wrapper", "Checkbox__input-wrapper--" + a]),
        children: [/* @__PURE__ */ r(Mn, Object.assign({
          id: B,
          type: "checkbox",
          "aria-label": (typeof b == "string" || typeof b == "number") && "" + b || "checkbox",
          "aria-describedby": I ? B + "-helper-text" : void 0,
          checked: s > 0,
          disabled: v,
          value: E,
          onChange: z,
          className: f(["CheckBox", {
            "CheckBox--error": y
          }]),
          onKeyDown: J,
          required: D,
          "aria-disabled": v,
          "aria-invalid": y
        }, K)), s !== $e.UNCHECKED && /* @__PURE__ */ r(On, {
          className: f(["CheckBox__checkmark-container", {
            "CheckBox__checkmark-container--disabled": v,
            "CheckBox__checkmark-container--error": y
          }]),
          children: /* @__PURE__ */ r(je, {
            icon: re ? "subtract" : "checkmark"
          })
        })]
      }), /* @__PURE__ */ M(Bn, {
        className: f(["CheckBox__content", "CheckBox__content--" + a, {
          "CheckBox__content--disabled": v
        }]),
        children: [b && /* @__PURE__ */ r($n, Object.assign({
          labelProp: {
            label: b,
            htmlFor: B
          },
          className: f(["CheckBox__content-container", "CheckBox__content-container--" + a])
        }, a !== "tile" && L && {
          infoProp: {
            infoText: L,
            infoType: "tooltip"
          }
        })), I && /* @__PURE__ */ r(Qe, {
          defaultProp: {
            id: B + "-helper-text",
            helperText: I
          }
        })]
      })]
    }), a === "tile" && h && /* @__PURE__ */ r(Pn, {
      className: f("Checkbox__media", {
        "Checkbox__media--disabled": v
      }),
      children: "src" in h ? /* @__PURE__ */ r(En, {
        src: h == null ? void 0 : h.src,
        alt: h == null ? void 0 : h.alt,
        sizes: "l",
        className: "Checkbox__image"
      }) : "iconName" in h && /* @__PURE__ */ r(je, {
        icon: h.iconName,
        size: "l",
        extended: !0,
        "data-testid": "Tile__icon"
      })
    })]
  }));
}, Ln = wt;
Ln({ target: "Number", stat: !0, nonConfigurable: !0, nonWritable: !0 }, {
  MAX_SAFE_INTEGER: 9007199254740991
});
var jn = /* @__PURE__ */ u.fieldset.withConfig({
  displayName: "checkboxGroupstyles__CheckBoxGroupFieldSet",
  componentId: "sc-95usjz-0"
})(["&.CheckboxGroup__fieldset{", ";}"], function(t) {
  var e = t.theme.components.checkbox;
  return p(e.CheckBoxGroupFieldSet);
}), zn = /* @__PURE__ */ u.div.withConfig({
  displayName: "checkboxGroupstyles__CheckboxGroupContainer",
  componentId: "sc-95usjz-1"
})(["&.CheckboxGroup{", ";}"], function(t) {
  var e = t.theme.components.checkbox;
  return p(e.CheckboxGroup);
}), Gn = ["variant", "size", "onChange", "isIntermediate", "isHorizontal", "helperTextProp", "labelProps", "inputState", "children", "className"], Wn = ze(), Pt = "CheckboxGroup", co = function(e) {
  var n, a, o, i = e.variant, m = i === void 0 ? "default" : i, v = e.size, k = v === void 0 ? "small" : v, s = e.onChange, g = e.isIntermediate, y = g === void 0 ? !1 : g, I = e.isHorizontal, b = I === void 0 ? !1 : I, E = e.helperTextProp, C = e.labelProps, T = e.inputState, A = T === void 0 ? De.NONE : T, L = e.children, D = L === void 0 ? [] : L, h = e.className, j = le(e, Gn), K = ye({
    label: "CheckboxGroup"
  }), G = we(ze(Pt)), B = G.current + "_label_id", z = Ce([]), J = z[0], re = z[1], ne = Je(function() {
    return [].concat(D);
  }, [D]), Y = E, W = A;
  if (E)
    Y = Object.assign({}, E, {
      inputState: W,
      secondaryProp: Object.assign({}, E.secondaryProp)
    });
  else {
    var ve;
    Y = (ve = {
      inputState: W
    }, ve[W === De.ERROR ? "secondaryProp" : "defaultProp"] = {
      id: (W === De.ERROR ? "invalid" : "valid") + "_" + Pt + "_helperText"
    }, ve);
  }
  ge(function() {
    re(function(U) {
      return ne.map(function(x, q) {
        var ae;
        return {
          value: (x == null ? void 0 : x.props.checkboxValue) || ((ae = U[q]) == null ? void 0 : ae.value) || $e.UNCHECKED,
          isIntermediate: x.props.isIntermediate !== void 0 ? x.props.isIntermediate : y || !1
        };
      });
    });
  }, [ne, y]);
  var ce = function(x) {
    var q = [].concat(J);
    x >= J.length || (q[x].value += 1, q[x].value = q[x].isIntermediate ? q[x].value % 3 : q[x].value % 2, re(q));
  }, Re = function() {
    return ne.map(function(x, q) {
      var ae, w, O = q + 1, se = x.props.disabled, de = x.props.isIntermediate !== void 0 ? x.props.isIntermediate : y || !1, Z = x.props.checkboxValue || ((ae = J[q]) == null ? void 0 : ae.value), R = x.props.error === !1 ? !1 : W === "error";
      return /* @__PURE__ */ Ee.cloneElement(x, {
        key: q,
        checkboxValue: Z,
        disabled: se,
        error: R,
        variant: m,
        size: x.props.size || k,
        onChange: function(Ie, oe) {
          x.props.onChange == null || x.props.onChange(Ie, oe), s == null || s(Ie), ce(q);
        },
        isIntermediate: de,
        id: (w = x.props.id) != null ? w : "FPDSCheckboxComponent" + O + "-" + Wn
      });
    });
  };
  return /* @__PURE__ */ M(jn, Object.assign({
    className: f([h, "CheckboxGroup__fieldset", "CheckboxGroup__fieldset--" + m])
  }, K, j, {
    children: [/* @__PURE__ */ r(vt, {
      className: "CheckboxGroup__legend",
      renderAs: "legend",
      labelProp: {
        id: B,
        htmlFor: G.current,
        label: C == null || (n = C.labelProp) == null ? void 0 : n.label,
        showRequiredIndicator: (a = C == null || (o = C.labelProp) == null ? void 0 : o.showRequiredIndicator) != null ? a : !1
      },
      infoProp: C == null ? void 0 : C.infoProp,
      trailingText: C == null ? void 0 : C.trailingText
    }), /* @__PURE__ */ r(zn, {
      className: f(["CheckboxGroup", "CheckboxGroup--" + k, "CheckboxGroup--" + m, {
        "CheckboxGroup--horizontal": b,
        "CheckboxGroup--vertical": !b
      }]),
      children: Re()
    }), /* @__PURE__ */ r(Qe, Object.assign({}, Y, {
      inputState: A
    }))]
  }));
}, qn = ["startAdornmentProp", "endAdornmentProp", "labelProp", "defaultValue", "disabled", "placeholder", "value", "required", "inputRef", "className", "pattern", "textSize", "children", "infoProp", "helperTextProp", "trailingText", "accessibilityOptions", "inputState", "trailingElement"], Fn = "TextInput", Hn = /* @__PURE__ */ u.div.withConfig({
  displayName: "textInput__TextInputWrapper",
  componentId: "sc-11djxc3-0"
})(["&.TextInput-wrapper{", ";}"], function(t) {
  var e = t.theme.components.textInput;
  return p(e.TextInputWrapper);
}), Kn = /* @__PURE__ */ u.div.withConfig({
  displayName: "textInput__InputContainer",
  componentId: "sc-11djxc3-1"
})(["&.TextInput__input-container{", ";}"], function(t) {
  var e = t.theme.components.textInput;
  return p(e.InputContainer);
}), Un = /* @__PURE__ */ u.input.withConfig({
  displayName: "textInput__BaseTextInput",
  componentId: "sc-11djxc3-2"
})(["&.TextInput__input{", ";}"], function(t) {
  var e = t.theme.components.textInput;
  return p(e.BaseTextInput);
}), Et = /* @__PURE__ */ u.div.withConfig({
  displayName: "textInput__AdornmentWrapper",
  componentId: "sc-11djxc3-3"
})(["&.TextInput__adornment{", ";}"], function(t) {
  var e = t.theme.components.textInput;
  return p(e.AdornmentWrapper);
}), ct = /* @__PURE__ */ Be(function(t, e) {
  var n, a, o, i, m, v, k, s, g, y = t.startAdornmentProp, I = t.endAdornmentProp, b = t.labelProp, E = t.defaultValue, C = t.disabled, T = t.placeholder, A = T === void 0 ? "Placeholder" : T, L = t.value, D = t.required, h = t.inputRef, j = t.className, K = t.pattern, G = t.textSize, B = G === void 0 ? "medium" : G;
  t.children;
  var z = t.infoProp, J = t.helperTextProp, re = t.trailingText, ne = t.accessibilityOptions, Y = ne === void 0 ? {} : ne, W = t.inputState, ve = t.trailingElement, ce = le(t, qn), Re = ye({
    label: "TextInput"
  }), U = we(ze(Fn)), x = we(null), q = U.current + "_label_id", ae = W || De.NONE, w = J;
  W || (ae = De.NONE), w = Object.assign({}, J, {
    inputState: ae
  });
  var O = {
    defaultId: ((n = w) == null || (n = n.defaultProp) == null ? void 0 : n.id) || "default_" + U.current + "_message_id",
    secondaryId: ((a = w) == null || (a = a.secondaryProp) == null ? void 0 : a.id) || "secondary_" + U.current + "_message_id"
  }, se = !!((o = w) != null && (o = o.defaultProp) != null && (o = o.helperText) != null && o.trim().length), de = !!((i = w) != null && (i = i.secondaryProp) != null && (i = i.helperText) != null && i.trim().length) && ((m = w) == null ? void 0 : m.inputState) !== De.NONE, Z = b != null && b.label ? q : "";
  se && (Z += " " + (O == null ? void 0 : O.defaultId)), de && (Z += " " + (O == null ? void 0 : O.secondaryId));
  var R = xn("input", Object.assign({
    ariaDisabled: C,
    ariaInvalid: w.inputState === "caution" || ((v = w) == null ? void 0 : v.inputState) === "error",
    ariaRequired: D,
    ariaLabelledBy: Z || void 0
  }, Y)), ke = function(oe) {
    if (x != null && x.current) {
      var S;
      (S = x.current) == null || S.focus(), oe.preventDefault();
    }
    oe.stopPropagation();
  };
  return /* @__PURE__ */ M(Hn, Object.assign({
    ref: e,
    className: f(["TextInput-wrapper", j])
  }, Re, {
    children: [/* @__PURE__ */ r(vt, {
      className: f(["TextInput__label", {
        "TextInput__label--disabled": C
      }]),
      labelProp: Object.assign({
        showRequiredIndicator: D,
        success: ae === De.SUCCESS,
        id: q,
        htmlFor: ce.id || U.current
      }, b),
      infoProp: Object.assign({
        infoText: "",
        infoType: "tooltip",
        popupTipHeader: "Info"
      }, z),
      trailingElement: ve,
      trailingText: re,
      onClick: ke
    }), /* @__PURE__ */ M(Kn, {
      className: f(["TextInput__input-container", "TextInput__input-container--" + B, "TextInput__input-container--" + (ae || "none"), {
        "TextInput__input-container--disabled": C
      }]),
      "data-trigger": "true",
      tabIndex: -1,
      children: [(y == null ? void 0 : y.startAdornment) && /* @__PURE__ */ r(Et, {
        className: f(["TextInput__adornment", "TextInput__adornment--start", {
          "TextInput__adornment--disabled": C
        }]),
        onClick: y == null ? void 0 : y.onClick,
        children: y == null ? void 0 : y.startAdornment
      }), /* @__PURE__ */ r(Un, Object.assign({
        disabled: C,
        value: L,
        placeholder: A,
        defaultValue: E,
        ref: Tn(x, h),
        id: ce.id || U.current,
        required: D,
        pattern: K
      }, R, ce, {
        className: "TextInput__input"
      })), (I == null ? void 0 : I.endAdornment) && /* @__PURE__ */ r(Et, {
        className: f(["TextInput__adornment", "TextInput__adornment--end", {
          "TextInput__adornment--disabled": C
        }]),
        onClick: I == null ? void 0 : I.onClick,
        children: I == null ? void 0 : I.endAdornment
      })]
    }), /* @__PURE__ */ r(Qe, {
      secondaryProp: Object.assign({
        id: O.secondaryId
      }, (k = w) == null ? void 0 : k.secondaryProp),
      inputState: ae,
      defaultProp: Object.assign({
        id: O.defaultId,
        helperText: ((s = w) == null || (s = s.defaultProp) == null ? void 0 : s.helperText) || ""
      }, (g = w) == null ? void 0 : g.defaultProp),
      disabled: C
    })]
  }));
}), xt = function(e) {
  return e.replace(/[^a-zA-Z0-9]/g, "_");
}, Vn = /* @__PURE__ */ u.div.withConfig({
  displayName: "dropdownMenuBasestyles__MainWrapper",
  componentId: "sc-1tzx6ew-0"
})(["&.DropdownBase__wrapper{", ";}"], function(t) {
  var e = t.theme.components.dropdownMenuBase;
  return p(e.MainWrapper);
}), Yn = /* @__PURE__ */ u.div.withConfig({
  displayName: "dropdownMenuBasestyles__TriggerWrapper",
  componentId: "sc-1tzx6ew-1"
})(["&.DropdownBase__trigger-wrapper{", ";}"], function(t) {
  var e = t.theme.components.dropdownMenuBase;
  return p(e.TriggerWrapper);
}), Xn = /* @__PURE__ */ u.div.withConfig({
  displayName: "dropdownMenuBasestyles__ContentWrapper",
  componentId: "sc-1tzx6ew-2"
})(["@keyframes menuOpen{0%{transform:scaleY(0);}100%{transform:scaleY(1);}}@keyframes menuClose{0%{transform:scaleY(1);display:block;}99%{transform:scaleY(0);display:block;}100%{transform:scaleY(0);display:none;}}&.DropdownBase__content-wrapper{", ";}"], function(t) {
  var e = t.theme.components.dropdownMenuBase;
  return p(e.ContentWrapper);
}), Jn = /* @__PURE__ */ u.ul.withConfig({
  displayName: "dropdownMenuBasestyles__ContentList",
  componentId: "sc-1tzx6ew-3"
})(["&.DropdownBase__Content-list{", ";}"], function(t) {
  var e, n = t.theme.components.dropdownMenuBase, a = t.$maxItems, o = t.$hiddenClasses, i = o.map(function(m) {
    return "_" + xt(m);
  }).join(", li.");
  return p(n.ContentList, (e = {
    maxHeight: a * 40 + "px"
  }, e["li." + i] = {
    display: "block"
  }, e));
}), ut = /* @__PURE__ */ u.div.withConfig({
  displayName: "dropdownMenuBasestyles__Divider",
  componentId: "sc-1tzx6ew-4"
})(["", ";"], function(t) {
  var e = t.theme.components.dropdownMenuBase;
  return p(e.Divider);
}), Vt = /* @__PURE__ */ u.div.withConfig({
  displayName: "dropdownMenuBasestyles__Title",
  componentId: "sc-1tzx6ew-5"
})(["", ";"], function(t) {
  var e = t.theme.components.dropdownMenuBase;
  return p(e.Title);
}), Zn = /* @__PURE__ */ u.div.withConfig({
  displayName: "dropdownMenuBasestyles__Control",
  componentId: "sc-1tzx6ew-6"
})(["", ";"], function(t) {
  var e = t.theme.components.dropdownMenuBase;
  return p(e.Control);
}), Qn = /* @__PURE__ */ u.div.withConfig({
  displayName: "dropdownMenuBasestyles__LocalSearchWrapper",
  componentId: "sc-1tzx6ew-7"
})(["&.DropdownBase-local-search{", ";}"], function(t) {
  var e = t.theme.components.dropdownMenuBase;
  return p(e.LocalSearchWrapper);
}), ea = /* @__PURE__ */ u.div.withConfig({
  displayName: "dropdownMenuBasestyles__SelectAllWrapper",
  componentId: "sc-1tzx6ew-8"
})(["&.DropdownBase__select-all-wrapper{", ";}"], function(t) {
  var e = t.theme.components.dropdownMenuBase;
  return p(e.SelectAllWrapper);
}), ta = /* @__PURE__ */ u.div.withConfig({
  displayName: "dropdownMenuBasestyles__NoResult",
  componentId: "sc-1tzx6ew-9"
})(["", ";"], function(t) {
  var e = t.theme.components.dropdownMenuBase;
  return p(e.NoResult);
}), na = /* @__PURE__ */ u.label.withConfig({
  displayName: "radiostyles__Label",
  componentId: "sc-1s5u8jv-0"
})(["&.Radio__Label{", "}"], function(t) {
  var e = t.theme.components.radio;
  return p(e.Label);
}), aa = /* @__PURE__ */ u.div.withConfig({
  displayName: "radiostyles__LabelContent",
  componentId: "sc-1s5u8jv-1"
})(["&.Label__content{", "}"], function(t) {
  var e = t.theme.components.radio;
  return p(e.LabelContent);
}), ra = /* @__PURE__ */ u.input.withConfig({
  displayName: "radiostyles__RadioButton",
  componentId: "sc-1s5u8jv-2"
})(["&.RadioButton{", "}"], function(t) {
  var e = t.theme.components.radio;
  return p(e.RadioButton);
}), oa = /* @__PURE__ */ u.div.withConfig({
  displayName: "radiostyles__Content",
  componentId: "sc-1s5u8jv-3"
})(["&.Radio__Content{", "}"], function(t) {
  var e = t.theme.components.radio;
  return p(e.Content);
}), ia = /* @__PURE__ */ u.div.withConfig({
  displayName: "radiostyles__Media",
  componentId: "sc-1s5u8jv-4"
})(["&.Radio__media{", ";}"], function(t) {
  var e = t.theme.components.radio;
  return p(e.Media);
}), la = /* @__PURE__ */ u(Ft).withConfig({
  displayName: "radiostyles__TileImage",
  componentId: "sc-1s5u8jv-5"
})(["&.Radio__image{", ";}"], function(t) {
  var e = t.theme.components.radio;
  return p(e.TileImage);
}), sa = ["variant", "size", "checked", "label", "error", "description", "horizontal", "disabled", "id", "name", "key", "onChange", "value", "className", "dataTestId", "media", "hideRadio", "required", "inputRef", "children"], da = "RADIO_DATA_TEST_ID", ca = "RADIO_WRAPPER_DATA_TEST_ID", pt = function(e) {
  var n = e.variant, a = n === void 0 ? "default" : n, o = e.size, i = o === void 0 ? "small" : o, m = e.checked, v = e.label, k = e.error, s = k === void 0 ? !1 : k, g = e.description, y = e.horizontal, I = e.disabled, b = e.id, E = e.name, C = e.key, T = e.onChange, A = e.value, L = e.className, D = e.dataTestId, h = D === void 0 ? da : D, j = e.media, K = e.hideRadio, G = e.required, B = G === void 0 ? !1 : G, z = e.inputRef, J = e.children, re = le(e, sa), ne = ye({
    label: "Radio"
  }), Y = b || ze("Radio"), W = a === "tile";
  return /* @__PURE__ */ M(na, Object.assign({
    className: f(["Radio__Label", "Radio__Label--" + a, {
      "Radio__Label--disabled": I
    }, L]),
    "data-testid": ca,
    htmlFor: Y
  }, ne, {
    children: [/* @__PURE__ */ M(aa, {
      className: "Label__content",
      children: [/* @__PURE__ */ r(ra, Object.assign({}, re, {
        id: Y,
        name: E ?? b,
        "data-testid": h,
        type: "radio",
        value: A,
        checked: m,
        disabled: I,
        required: m === !0 ? B : !1,
        "aria-invalid": s,
        onChange: function(ce) {
          return T == null ? void 0 : T(A, ce);
        },
        className: f(["RadioButton", "RadioButton--" + i, "RadioButton--" + a, {
          "RadioButton--error": s,
          "RadioButton--hideRadio": K && W
        }]),
        ref: z
      })), (v || g) && /* @__PURE__ */ M(oa, {
        className: f(["Radio__Content", "Radio__Content--" + i, "Radio__Content--" + a, {
          "Radio__Content--disabled": I,
          "Radio__Content--horizontal": y,
          "Radio__Content--vertical": !y
        }]),
        children: [v && /* @__PURE__ */ r("span", {
          className: "title",
          children: v
        }), g && /* @__PURE__ */ r(Qe, {
          defaultProp: {
            id: Y + "-helper-text",
            helperText: g
          }
        })]
      })]
    }), a === "tile" && j && /* @__PURE__ */ r(ia, {
      className: f(["Radio__media", {
        "Radio__media--disabled": I
      }]),
      children: "src" in j ? /* @__PURE__ */ r(la, {
        src: j == null ? void 0 : j.src,
        alt: j == null ? void 0 : j.alt,
        sizes: "l",
        className: "Radio__image"
      }) : "iconName" in j && /* @__PURE__ */ r(je, {
        icon: j.iconName,
        size: "l",
        extended: !0,
        "data-testid": "Tile__icon"
      })
    }), J]
  }), C);
}, ua = ["children"], Yt = /* @__PURE__ */ Be(function(t, e) {
  var n = t.children, a = le(t, ua);
  return /* @__PURE__ */ r(Tt.P, Object.assign({
    size: "small",
    fontWeight: "regular"
  }, a, {
    className: f("MapCard__Content-Description", a.className),
    ref: e,
    children: n
  }));
}), pa = /* @__PURE__ */ Be(function(t, e) {
  var n = Object.assign({}, (mt(t), t));
  return /* @__PURE__ */ r(Yt, Object.assign({}, n, {
    ref: e
  }));
}), ma = /* @__PURE__ */ u(pt).withConfig({
  displayName: "mapCardstyles__RadioTile",
  componentId: "sc-1isd2uq-0"
})(["&.MapCard__Container{", "}"], function(t) {
  var e = t.theme.components.mapCard;
  return p(e.MapCardContainer);
}), va = /* @__PURE__ */ u.section.withConfig({
  displayName: "mapCardstyles__Section",
  componentId: "sc-1isd2uq-1"
})(["&.MapCard__Section{", "}"], function(t) {
  var e = t.theme.components.mapCard;
  return p(e.CardContentWrapper);
}), Xt = /* @__PURE__ */ u.div.withConfig({
  displayName: "mapCardstyles__Content",
  componentId: "sc-1isd2uq-2"
})(["&.MapCard__Content{", "}"], function(t) {
  var e = t.theme.components.mapCard;
  return p(e.CardContent);
}), Jt = /* @__PURE__ */ u.div.withConfig({
  displayName: "mapCardstyles__ContentHeader",
  componentId: "sc-1isd2uq-3"
})(["&.MapCard__Content-Header{", "}"], function(t) {
  var e = t.theme.components.mapCard;
  return p(e.ContentHeader);
}), ha = /* @__PURE__ */ u.div.withConfig({
  displayName: "mapCardstyles__Title",
  componentId: "sc-1isd2uq-4"
})(["&.MapCard__Title{", "}"], function(t) {
  var e = t.theme.components.mapCard;
  return p(e.Title);
}), fa = /* @__PURE__ */ u.footer.withConfig({
  displayName: "mapCardstyles__Footer",
  componentId: "sc-1isd2uq-5"
})(["&.MapCard__Footer{", "}"], function(t) {
  var e = t.theme.components.mapCard;
  return p(e.Footer);
}), gt = /* @__PURE__ */ u.div.withConfig({
  displayName: "mapCardstyles__ContentWrapper",
  componentId: "sc-1isd2uq-6"
})(["&.MapCard__Footer-ContentWrapper{", "}"], function(t) {
  var e = t.theme.components.mapCard;
  return p(e.ContentWrapper);
}), ba = /* @__PURE__ */ u.div.withConfig({
  displayName: "mapCardstyles__MapCardGroup",
  componentId: "sc-1isd2uq-7"
})(["&.MapCard__Group_Wrapper{", "}"], function(t) {
  var e = t.theme.components.mapCard;
  return p(e.MapCardGroup);
}), ga = ["children"], Pe = /* @__PURE__ */ Be(function(t, e) {
  var n = t.children, a = le(t, ga), o = ee(n, {
    Buttons: dt,
    Links: _t,
    LeftDescription: Pe.LeftDescription,
    RightDescription: Pe.RightDescription
  }, ee.PickType.ALL), i = ee(n, {
    LeftDescription: Pe.LeftDescription,
    RightDescription: Pe.RightDescription
  }, ee.PickType.LAST);
  return /* @__PURE__ */ M(fa, Object.assign({}, a, {
    ref: e,
    className: f(["MapCard__Footer", a.className]),
    children: [(i.LeftDescription || i.RightDescription) && /* @__PURE__ */ r(gt, {
      className: "MapCard__Footer-ContentWrapper MapCard__Footer-ContentWrapper-Description",
      children: [i.LeftDescription, i.RightDescription]
    }), o.Buttons.length > 0 && /* @__PURE__ */ r(gt, {
      className: "MapCard__Footer-ContentWrapper",
      children: Mt(o.Buttons.slice(-2), function(m, v) {
        return /* @__PURE__ */ r(dt, Object.assign({}, m, {
          onClick: function(s) {
            s.stopPropagation(), m.onClick == null || m.onClick(s);
          },
          onKeyDown: function(s) {
            s.stopPropagation(), m.onKeyDown == null || m.onKeyDown(s);
          }
        }), v);
      })
    }), o.Links.length > 0 && /* @__PURE__ */ r(gt, {
      className: "MapCard__Footer-ContentWrapper",
      children: Mt(o.Links.slice(-2), function(m, v) {
        return /* @__PURE__ */ r(_t, Object.assign({}, m, {
          onClick: function(s) {
            s.stopPropagation(), m.onClick == null || m.onClick(s);
          },
          onKeyDown: function(s) {
            s.stopPropagation(), m.onKeyDown == null || m.onKeyDown(s);
          }
        }), v);
      })
    })]
  }));
});
Pe.Button = dt;
Pe.Link = _t;
Pe.LeftDescription = Yt;
Pe.RightDescription = pa;
var _a = ["children"], Zt = /* @__PURE__ */ Be(function(t, e) {
  var n = t.children, a = le(t, _a);
  return /* @__PURE__ */ r(Tt.P, Object.assign({
    size: "small",
    fontWeight: "medium"
  }, a, {
    className: f("MapCard__Content-SubTitle", a.className),
    ref: e,
    children: n
  }));
}), Ca = /* @__PURE__ */ u.div.withConfig({
  displayName: "tagstyles__Tag",
  componentId: "sc-1rfdr4i-0"
})(["&.Tag{", ";}"], function(t) {
  var e = t.theme.components.tag;
  return p(e.Container);
}), wa = /* @__PURE__ */ u.span.withConfig({
  displayName: "tagstyles__Title",
  componentId: "sc-1rfdr4i-1"
})(["&.Tag__title{", ";}"], function(t) {
  var e = t.theme.components.tag;
  return p(e.TitleWrapper);
}), Ta = /* @__PURE__ */ u(Ht).withConfig({
  displayName: "tagstyles__CloseButton",
  componentId: "sc-1rfdr4i-2"
})(["&.Tag__close-btn{", ";}"], function(t) {
  var e = t.theme.components.tag;
  return p(e.CloseIconWrapper);
}), Qt = /* @__PURE__ */ Wt({}), xa = ["variant", "size", "stroke", "title", "leadingIcon", "onDelete", "accessibilityOptions", "className", "children"], At = {
  accent: "info",
  success: "success",
  caution: "caution",
  danger: "danger",
  default: "default"
}, Ve = function(e) {
  var n, a, o = e.variant, i = o === void 0 ? "default" : o, m = e.size, v = m === void 0 ? "medium" : m, k = e.stroke, s = e.title, g = e.leadingIcon, y = e.onDelete, I = e.accessibilityOptions, b = e.className, E = e.children, C = le(e, xa), T = ye({
    label: "Tag"
  }), A = qt(Qt), L = A.size, D = L === void 0 ? v : L, h = A.stroke, j = h === void 0 ? k : h, K = ee(E, {
    CloseButton: Ve.CloseButton
  }, ee.PickType.LAST);
  return /* @__PURE__ */ M(Ca, Object.assign({
    className: f(["Tag", "Tag--" + i, "Tag--" + D, {
      "Tag--stroke": j
    }, b])
  }, T, C, {
    children: [/* @__PURE__ */ r(je, {
      icon: g,
      size: "xs"
    }), s && /* @__PURE__ */ r(wa, {
      className: f(["Tag__title", "Tag__title--" + v]),
      children: s
    }), !!y && /* @__PURE__ */ r(Ta, Object.assign({}, (n = K.CloseButton) == null ? void 0 : n.props, {
      className: f("Tag__close-btn", "Tag__close-btn--" + At[i], "Tag__close-btn--" + D, (a = K.CloseButton) == null ? void 0 : a.props.className),
      onClick: function(B) {
        B.preventDefault(), B.stopPropagation(), y == null || y(B);
      },
      size: "xxxsmall",
      color: At[i]
    }, Ue("button", I)))]
  }));
};
Ve.CloseButton = Ht;
var ya = /* @__PURE__ */ u.div.withConfig({
  displayName: "tagsGroupstyles__Container",
  componentId: "sc-1ddm3v7-0"
})(["&.TagsGroup{", ";}"], function(t) {
  var e = t.theme.components.tag;
  return p(e.TagGroupContainer);
}), ka = /* @__PURE__ */ u.button.withConfig({
  displayName: "tagsGroupstyles__OverflowButton",
  componentId: "sc-1ddm3v7-1"
})(["&.TagsGroup__overflow-button{", ";}"], function(t) {
  var e = t.theme.components.tag;
  return p(e.OverflowButton);
}), Ia = ["overflowVariant", "stroke", "size", "overflow", "children", "onClick", "visibleTags", "_maxTagCount", "className"], Ze = function(e) {
  var n, a, o, i = e.overflowVariant, m = i === void 0 ? "default" : i, v = e.stroke, k = e.size, s = e.overflow, g = e.children, y = g === void 0 ? [] : g, I = e.onClick, b = e.visibleTags, E = b === void 0 ? 0 : b, C = e._maxTagCount, T = e.className, A = le(e, Ia), L = ye({
    label: "TagGroup"
  }), D = Ce(!0), h = D[0], j = D[1], K = ee(y, {
    tags: Ze.Tag,
    OverflowButton: Ze.OverflowButton
  }), G = C !== void 0 ? K.tags.slice(0, C) : K.tags, B = G.length - E, z = function() {
    j(!1), I && I();
  };
  return /* @__PURE__ */ r(Qt.Provider, {
    value: {
      size: k,
      stroke: v
    },
    children: /* @__PURE__ */ M(ya, Object.assign({
      className: f(["TagsGroup", "TagsGroup--" + m, (n = {}, n["TagsGroup--" + k] = k, n), T])
    }, L, A, {
      children: [h && s ? G.slice(0, E) : G, s && h && B > 0 && /* @__PURE__ */ M(ka, Object.assign({
        role: "button",
        "aria-label": "Collapsed tags count: " + B
      }, (a = K.OverflowButton.at(-1)) == null ? void 0 : a.props, {
        onClick: z,
        className: f(["TagsGroup__overflow-button", "TagsGroup__overflow-button--" + m, "TagsGroup__overflow-button--" + k, {
          "TagsGroup__overflow-button--stroke": v
        }, (o = K.OverflowButton.at(-1)) == null ? void 0 : o.props.className]),
        children: ["+", B]
      }))]
    }))
  });
};
Ze.Tag = Ve;
Ze.OverflowButton = dt;
var Na = ["stroke"], et = function(e) {
  var n = e.stroke, a = n === void 0 ? !0 : n, o = le(e, Na), i = ee(o.children, {
    Tag: Ve
  }, ee.PickType.ALL);
  return /* @__PURE__ */ r(Ze, Object.assign({
    stroke: a
    // By default TagsGroup has stroke
  }, o, {
    children: i.Tag.length > 0 && i.Tag.map(function(m, v) {
      return /* @__PURE__ */ r(Ve, Object.assign({}, m == null ? void 0 : m.props), v);
    })
  }));
};
et.Tag = Ve;
var Se = /* @__PURE__ */ Be(function(t, e) {
  var n = Object.assign({}, (mt(t), t)), a = ee(n.leadingMarker, {
    Icon: Se.Icon,
    Badge: Se.Badge
  }, ee.PickType.LAST), o = ee(n.trailingMarker, {
    Icon: Se.Icon,
    Badge: Se.Badge
  }, ee.PickType.LAST);
  return /* @__PURE__ */ M(ha, Object.assign({}, n, {
    className: f(["MapCard__Title", n.className]),
    ref: e,
    children: [a.Badge && /* @__PURE__ */ r(Ct, Object.assign({}, a.Badge.props, {
      size: "large"
    })), a.Icon && /* @__PURE__ */ r(je, Object.assign({}, a.Icon.props, {
      size: "l",
      extended: !1
    })), /* @__PURE__ */ r(Tt.P, {
      size: "medium",
      fontWeight: "medium",
      className: "MapCard__Title-text",
      as: "span",
      children: n.children
    }), o.Badge && /* @__PURE__ */ r(Ct, Object.assign({}, o.Badge.props, {
      size: "large"
    })), o.Icon && /* @__PURE__ */ r(je, Object.assign({}, o.Icon.props, {
      size: "l",
      extended: !1
    }))]
  }));
});
Se.Icon = je;
Se.Badge = Ct;
var Da = /* @__PURE__ */ Be(function(t, e) {
  var n = Object.assign({}, (mt(t), t));
  return /* @__PURE__ */ r(Se, Object.assign({}, n, {
    ref: e
  }));
}), Sa = ["children"], tt = /* @__PURE__ */ Be(function(t, e) {
  var n = t.children, a = le(t, Sa), o = ee(n, {
    Title: te.LeftTitle,
    SubTitle: te.SubTitle,
    Tags: te.Tags
  }, ee.PickType.LAST);
  return /* @__PURE__ */ M(Xt, Object.assign({}, a, {
    ref: e,
    className: f(["MapCard__Content", a.className]),
    children: [(o.Title || o.SubTitle) && /* @__PURE__ */ M(Jt, {
      className: "MapCard__Content-Header",
      children: [o.Title, o.SubTitle]
    }), o.Tags]
  }));
});
tt.Title = Se;
tt.SubTitle = Zt;
tt.Tags = et;
tt.Tags.Tag = et.Tag;
var Ba = ["children"], en = /* @__PURE__ */ Be(function(t, e) {
  var n = t.children, a = le(t, Ba), o = ee(n, {
    Title: te.RightTitle
  }, ee.PickType.LAST);
  return /* @__PURE__ */ r(Xt, Object.assign({}, a, {
    ref: e,
    className: f(["MapCard__Content", a.className]),
    children: o.Title && /* @__PURE__ */ r(Jt, {
      className: "MapCard__Content-Header",
      children: o.Title
    })
  }));
});
en.Title = Se;
var Ra = ["children"], te = /* @__PURE__ */ Be(function(t, e) {
  var n = t.children, a = le(t, Ra), o = ye({
    label: "MapCard"
  }), i = ee(n, {
    LeftTitle: te.LeftTitle,
    RightTitle: te.RightTitle,
    SubTitle: te.SubTitle,
    Tags: te.Tags,
    Footer: te.Footer
  }, ee.PickType.LAST);
  return /* @__PURE__ */ M(ma, Object.assign({
    variant: "tile",
    hideRadio: !0
  }, a, {
    ref: e,
    className: f(["MapCard__Container", a.className])
  }, o, {
    children: [/* @__PURE__ */ M(va, {
      className: "MapCard__Section",
      children: [(i.LeftTitle || i.SubTitle || i.Tags) && /* @__PURE__ */ r(tt, {
        children: [i.LeftTitle, i.SubTitle, i.Tags]
      }), i.RightTitle && /* @__PURE__ */ r(en, {
        children: i.RightTitle
      })]
    }), i.Footer]
  }));
});
te.Footer = Pe;
te.LeftTitle = Se;
te.RightTitle = Da;
te.SubTitle = Zt;
te.Tags = et;
te.Tags.Tag = et.Tag;
var Ma = ["children"], Oa = function(e) {
  var n = e.children, a = le(e, Ma), o = ee(n, {
    MapCard: te
  }), i = ye({
    label: "MapCardGroup"
  });
  return /* @__PURE__ */ r(ba, {
    className: "MapCard__Group_Wrapper",
    children: /* @__PURE__ */ r(ja, Object.assign({}, a, i, {
      variant: "tile",
      className: f(["MapCard_Group", a.className]),
      children: o.MapCard
    }))
  });
};
Oa.MapCard = te;
var $a = /* @__PURE__ */ u.fieldset.withConfig({
  displayName: "radioGroupstyles__RadioGroupFieldSet",
  componentId: "i9hmqc-0"
})(["&.RadioGroup__fieldset{", "}"], function(t) {
  var e = t.theme.components.radio;
  return p(e.RadioGroupFieldSet);
}), Pa = /* @__PURE__ */ u.div.withConfig({
  displayName: "radioGroupstyles__RadioGroupContainer",
  componentId: "i9hmqc-1"
})(["&.RadioGroup{", "}"], function(t) {
  var e = t.theme.components.radio;
  return p(e.RadioGroup);
}), Ea = ["variant", "size", "children", "horizontal", "value", "defaultValue", "onChange", "onBlur", "required", "className", "helperTextProp", "dataTestId", "inputState", "name", "hideRadio", "labelProps", "inputRef"], Aa = "RADIO_GROUP_DATA_TEST_ID", La = "RadioGroup", ja = function(e) {
  var n, a, o, i, m, v, k, s = e.variant, g = s === void 0 ? "default" : s, y = e.size, I = y === void 0 ? "small" : y, b = e.children, E = b === void 0 ? [] : b, C = e.horizontal, T = e.value, A = e.defaultValue, L = A === void 0 ? T : A, D = e.onChange, h = e.onBlur, j = e.required, K = j === void 0 ? !1 : j, G = e.className, B = e.helperTextProp, z = e.dataTestId, J = z === void 0 ? Aa : z, re = e.inputState, ne = e.name, Y = e.hideRadio, W = e.labelProps, ve = e.inputRef, ce = le(e, Ea), Re = ye({
    label: "RadioGroup"
  }), U = we(ze(La)), x = U.current + "_label_id", q = ne || U.current + "_name", ae = Je(function() {
    return [].concat(E);
  }, [E]), w = B, O = re || De.NONE, se = {
    defaultId: ((n = w) == null || (n = n.defaultProp) == null ? void 0 : n.id) || "default_" + U.current + "_message_id",
    secondaryId: ((a = w) == null || (a = a.secondaryProp) == null ? void 0 : a.id) || "secondary_" + U.current + "_message_id"
  };
  if (B) {
    var Z, R, ke;
    w = {
      inputState: re || O,
      defaultProp: {
        id: ((Z = B.defaultProp) == null ? void 0 : Z.id) || se.defaultId,
        helperText: ((R = B.defaultProp) == null ? void 0 : R.helperText) || ""
      },
      secondaryProp: Object.assign({}, B.secondaryProp, {
        id: ((ke = B.secondaryProp) == null ? void 0 : ke.id) || se.secondaryId
      })
    };
  } else {
    var de;
    w = (de = {
      inputState: O
    }, de[O === De.ERROR ? "secondaryProp" : "defaultProp"] = {
      id: "" + (O === De.ERROR ? se.secondaryId : se.defaultId)
    }, de);
  }
  var Ie = ce["aria-label"] + " " + (((o = w) == null || (o = o.defaultProp) == null ? void 0 : o.helperText) || "") + " " + (((i = w) == null || (i = i.secondaryProp) == null ? void 0 : i.helperText) || ""), oe = Ue("radiogroup", {
    ariaInvalid: re === "caution" || re === "error" || O === "error" || O === "caution",
    ariaLabel: Ie == null ? void 0 : Ie.trim()
  });
  return /* @__PURE__ */ M($a, Object.assign({
    "data-testid": J
  }, oe, {
    className: f(["RadioGroup__fieldset", "RadioGroup__fieldset--" + g, "RadioGroup__fieldset--legend", G])
  }, Re, ce, {
    children: [/* @__PURE__ */ r(vt, {
      renderAs: "legend",
      className: "RadioGroup__legend",
      labelProp: {
        id: x,
        htmlFor: U.current,
        label: W == null || (m = W.labelProp) == null ? void 0 : m.label,
        showRequiredIndicator: (v = W == null || (k = W.labelProp) == null ? void 0 : k.showRequiredIndicator) != null ? v : K
      },
      infoProp: W == null ? void 0 : W.infoProp,
      trailingText: W == null ? void 0 : W.trailingText
    }), /* @__PURE__ */ r(Pa, {
      className: f(["RadioGroup", "RadioGroup--" + I, "RadioGroup--" + g, {
        "RadioGroup--horizontal": C,
        "RadioGroup--vertical": !C
      }]),
      children: ae.filter(Boolean).map(function(S, $) {
        var qe, Fe, V, H, X, Te, _e, Ae, Le, He, at, Ye, rt, Xe, he, fe;
        return S.type === pt ? /* @__PURE__ */ r(pt, Object.assign({
          dataTestId: J + "_RADIO_BUTTON_" + ($ + 1)
        }, S.props, {
          name: (V = (H = S.props) == null ? void 0 : H.name) != null ? V : q,
          required: K,
          defaultChecked: typeof L < "u" ? ((X = S.props) == null ? void 0 : X.value) === L : (Te = S.props) == null ? void 0 : Te.defaultChecked,
          checked: typeof T < "u" ? ((_e = S.props) == null ? void 0 : _e.value) === T : (Ae = S.props) == null ? void 0 : Ae.checked,
          onChange: D,
          onBlur: h,
          onKeyDown: function(be) {
            if (!T && (be.code === "Enter" || be.code === "Space")) {
              var Me, Oe = be.target;
              Oe.checked = !0, (Me = S.props) == null || Me.onClick == null || Me.onClick(Oe.value, be), D == null || D(Oe.value, be);
            }
          },
          error: O === "error" || S.props.error,
          variant: g,
          size: I,
          hideRadio: Y,
          inputRef: $ === 0 ? ve : void 0
        }), (qe = (Fe = S.props) == null ? void 0 : Fe.label) != null ? qe : $) : S.type === te ? /* @__PURE__ */ r(te, Object.assign({
          dataTestId: J + "_MAP_CARD_" + ($ + 1)
        }, S.props, {
          name: (at = (Ye = S.props) == null ? void 0 : Ye.name) != null ? at : q,
          defaultChecked: typeof L < "u" ? ((rt = S.props) == null ? void 0 : rt.value) === L : (Xe = S.props) == null ? void 0 : Xe.defaultChecked,
          checked: typeof T < "u" ? ((he = S.props) == null ? void 0 : he.value) === T : (fe = S.props) == null ? void 0 : fe.checked,
          onChange: D,
          onBlur: h,
          onKeyDown: function(be) {
            if (!T && (be.code === "Enter" || be.code === "Space")) {
              var Me, Oe = be.target;
              Oe.checked = !0, (Me = S.props) == null || Me.onClick == null || Me.onClick(Oe.value, be), D == null || D(Oe.value, be);
            }
          },
          inputRef: $ === 0 ? ve : void 0
        }), (Le = (He = S.props) == null ? void 0 : He.label) != null ? Le : $) : S;
      })
    }), /* @__PURE__ */ r(Qe, Object.assign({}, w, {
      inputState: O
    }))]
  }));
}, za = /* @__PURE__ */ u.li.withConfig({
  displayName: "dropdownMenuBaseItemstyles__ListWrapper",
  componentId: "i18v44-0"
})(["&.DropdownBaseItem__List-wrapper{", ";}"], function(t) {
  var e = t.theme.components.dropdownMenuBase;
  return p(e.ListWrapper);
}), Ga = /* @__PURE__ */ u.span.withConfig({
  displayName: "dropdownMenuBaseItemstyles__ItemText",
  componentId: "i18v44-1"
})(["&.DropdownBaseItem__Item-text{", ";}"], function(t) {
  var e = t.theme.components.dropdownMenuBase;
  return p(e.ItemText);
}), Lt = /* @__PURE__ */ u.div.withConfig({
  displayName: "dropdownMenuBaseItemstyles__LeadingElementWrapper",
  componentId: "i18v44-2"
})(["&.DropdownBaseItem__Leading-element{", ";}"], function(t) {
  var e = t.theme.components.dropdownMenuBase;
  return p(e.LeadingElementWrapper);
}), Wa = /* @__PURE__ */ u.div.withConfig({
  displayName: "dropdownMenuBaseItemstyles__TrailingEletrailingElementWrapper",
  componentId: "i18v44-3"
})(["&.DropdownBaseItem__Trailing-element{", ";}"], function(t) {
  var e = t.theme.components.dropdownMenuBase;
  return p(e.TrailingElementWrapper);
}), qa = ["label", "value", "id", "description", "trailingElement", "leadingElement", "disabled", "className", "isSelected"], lt = /* @__PURE__ */ Ee.memo(function(t) {
  var e = t.value, n = t.disable, a = t.ariaLabel, o = we(null);
  return ge(function() {
    if (o != null && o.current) {
      var i;
      (i = o.current) == null || i.querySelector('input[type="checkbox"]').setAttribute("tabindex", "-1");
    }
  }, []), /* @__PURE__ */ r("span", {
    className: "check-wrapper",
    "aria-hidden": "true",
    tabIndex: -1,
    style: {
      pointerEvents: "none"
    },
    ref: o,
    children: /* @__PURE__ */ r(Ut, {
      label: "",
      "aria-label": a,
      checkboxValue: e,
      disabled: n
    })
  });
}), st = /* @__PURE__ */ Ee.memo(function(t) {
  var e = t.value, n = t.disable, a = t.ariaLabel, o = we(null);
  return ge(function() {
    if (o != null && o.current) {
      var i, m;
      (i = o.current) == null || i.querySelector('input[type="radio"]').setAttribute("tabindex", "-1"), (m = o.current) == null || m.querySelector("label.Radio__Label").setAttribute("tabindex", "-1");
    }
  }, []), /* @__PURE__ */ r("span", {
    className: "radio-section",
    ref: o,
    children: /* @__PURE__ */ r(pt, {
      checked: e,
      label: "",
      value: "",
      "aria-label": a,
      disabled: n
    })
  });
}), Fa = function(e) {
  return {
    radio: {
      default: [/* @__PURE__ */ r(st, {
        value: !1,
        ariaLabel: e,
        disable: !1
      }, "radio_unchecked"), /* @__PURE__ */ r(st, {
        value: !0,
        ariaLabel: e,
        disable: !1
      }, "radio_checked")],
      disabled: [/* @__PURE__ */ r(st, {
        ariaLabel: e,
        value: !1,
        disable: !0
      }, "radio_unchecked_disabled"), /* @__PURE__ */ r(st, {
        ariaLabel: e,
        value: !0,
        disable: !0
      }, "radio_checked_disabled")]
    },
    multiple: {
      default: [/* @__PURE__ */ r(lt, {
        value: 0,
        ariaLabel: e,
        disable: !1
      }, "box_unchecked"), /* @__PURE__ */ r(lt, {
        value: 2,
        ariaLabel: e,
        disable: !1
      }, "box_checked")],
      disabled: [/* @__PURE__ */ r(lt, {
        value: 0,
        ariaLabel: e,
        disable: !0
      }, "box_unchecked_disabled"), /* @__PURE__ */ r(lt, {
        value: 2,
        ariaLabel: e,
        disable: !0
      }, "box_checked_disabled")]
    }
  };
}, Ha = function(e) {
  var n = e.label, a = e.value, o = e.id, i = o === void 0 ? a : o, m = e.description, v = e.trailingElement, k = e.leadingElement, s = e.disabled, g = s === void 0 ? !1 : s, y = e.className, I = e.isSelected, b = I === void 0 ? !1 : I, E = le(e, qa), C = qt(tn), T = C.type, A = C.handleSelect, L = Ue("option", {
    ariaDisabled: g,
    ariaSelected: b,
    ariaLabel: n
  });
  return /* @__PURE__ */ r(za, Object.assign({
    role: "option",
    id: i,
    tabIndex: -1,
    disabled: g,
    "data-value": a,
    onKeyUp: function(h) {
      (h.code === "Space" || h.code === "Enter") && (h.preventDefault(), h.stopPropagation(), !g && A && A(h, a));
    },
    className: f(["DropdownBaseItem__List-wrapper", "list-item", {
      active: T === "default" && b && !g
    }, y, "_" + xt(a)])
  }, L, E, {
    onClick: function(h) {
      return !g && A(h, a);
    },
    children: /* @__PURE__ */ M(Ga, {
      tabIndex: -1,
      disabled: g,
      className: f(["DropdownBaseItem__Item-text", {
        "DropdownBaseItem__Item-text--disable": g
      }]),
      children: [T === "default" ? k && /* @__PURE__ */ r(Lt, {
        disabled: g,
        className: f(["DropdownBaseItem__Leading-element", {
          "DropdownBaseItem__Leading-element--disable": g
        }, "DropdownBaseItem__Leading-element--" + T]),
        children: k
      }) : /* @__PURE__ */ r(Lt, {
        disabled: g,
        className: f(["DropdownBaseItem__Leading-element", {
          "DropdownBaseItem__Leading-element--disable": g
        }, "DropdownBaseItem__Leading-element--" + T]),
        children: Fa(n)[T][g ? "disabled" : "default"][b ? 1 : 0]
      }), /* @__PURE__ */ M("div", {
        children: [/* @__PURE__ */ r("div", {
          className: "DropdownBaseItem__Item-text-title",
          children: n
        }), m]
      }), v && /* @__PURE__ */ r(Wa, {
        disabled: g,
        className: f(["DropdownBaseItem__Trailing-element", {
          "DropdownBaseItem__Trailing-element--disable": g
        }]),
        children: v
      })]
    })
  }));
};
const yt = /* @__PURE__ */ Ee.memo(Ha, function(t, e) {
  return t.value === e.value && t.id === e.id && t.isSelected === e.isSelected && t.className === e.className && t.disabled === e.disabled;
});
var Ka = ["children", "uniqueIdentifier", "handleMenuOpen", "onChange", "type", "menuHeader", "isDisabled", "menuDirection", "onBlur", "onClick", "noResultText", "closeOnSelect", "maxItems", "menuOpen", "className", "hiddenItems", "exceedOverflow", "accessibilityOptions", "fullWidth", "menuWidth", "disableAutoFocus", "_csMaskContent"];
function Ua(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n)
    return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = Va(t)) || e && t && typeof t.length == "number") {
    n && (t = n);
    var a = 0;
    return function() {
      return a >= t.length ? { done: !0 } : { done: !1, value: t[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Va(t, e) {
  if (t) {
    if (typeof t == "string")
      return jt(t, e);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? jt(t, e) : void 0;
  }
}
function jt(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, a = Array(e); n < e; n++)
    a[n] = t[n];
  return a;
}
var Ya = "Escape", tn = /* @__PURE__ */ Wt({}), zt = function(e, n, a) {
  var o = e == null ? void 0 : e.trimStart();
  return o = o.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), a.length > 0 ? n.filter(function(i) {
    return !a.includes(i.value);
  }).map(function(i) {
    return i.value;
  }) : n.filter(function(i) {
    return ("" + i.label + i.value).search(new RegExp(o, "i")) >= 0;
  }).map(function(i) {
    return i.value;
  });
}, Gt = function(e, n) {
  return n ? e === "up_auto" ? "up_left" : "down_left" : e;
}, Ne = function(e) {
  var n = e.children, a = e.uniqueIdentifier, o = e.handleMenuOpen, i = e.onChange, m = e.type, v = m === void 0 ? "default" : m, k = e.menuHeader, s = k === void 0 ? "default" : k, g = e.isDisabled, y = g === void 0 ? !1 : g, I = e.menuDirection, b = I === void 0 ? "down_left" : I, E = e.onBlur, C = e.onClick, T = e.noResultText, A = e.closeOnSelect, L = e.maxItems, D = L === void 0 ? 8 : L, h = e.menuOpen, j = e.className, K = e.hiddenItems, G = K === void 0 ? [] : K, B = e.exceedOverflow, z = B === void 0 ? !1 : B, J = e.accessibilityOptions, re = J === void 0 ? {} : J, ne = e.fullWidth, Y = ne === void 0 ? !1 : ne, W = e.menuWidth, ve = W === void 0 ? "280px" : W, ce = e.disableAutoFocus, Re = ce === void 0 ? !1 : ce, U = e._csMaskContent, x = le(e, Ka), q = ye({
    label: "DropdownMenuBase"
  }), ae = bn("DropdownMenuBase"), w = ae.t, O = Ce(-1), se = O[0], de = O[1], Z = we(null), R = we([]);
  R.current.callbacks = {
    onChange: i,
    onBlur: E,
    onClick: C
  };
  var ke = Ce(!0), Ie = ke[0], oe = ke[1], S = we(ze("dd")), $ = a || S.current, qe = re.menuIcon, Fe = Ue("button", Object.assign({
    ariaLabel: w("Dropdown menu", "iconAriaLabel"),
    ariaExpanded: h ? "true" : "false",
    ariaControls: "list-" + $
  }, qe)), V = Ce(""), H = V[0], X = V[1], Te = Ce(["menu-header"]), _e = Te[0], Ae = Te[1], Le = Ce(!1), He = Le[0], at = Le[1], Ye = Ce({}), rt = Ye[0], Xe = Ye[1], he = we(null), fe = we(null), ot = _n(), be = ot.width, Me = ot.height, Oe = Ue("region", {
    ariaHidden: !h
  }), rn = Ue("listbox", {
    ariaMultiselectable: v === "multiple",
    ariaLabel: w("unordered list", "listboxAriaLabel") + " " + $
  }), kt = /* @__PURE__ */ r(Cn, Object.assign({
    id: "control-" + $,
    role: "button"
  }, Fe)), on = Je(function() {
    var c = !0;
    R.current.list = [], R.current.currentEle = !0, R.current.controlElement = kt;
    var l = Ee.Children.map(n, function(d) {
      if (!(d && /* @__PURE__ */ Ee.isValidElement(d)))
        return null;
      if (d.type === Ne.Control)
        R.current.controlElement = d;
      else {
        if (d.type === yt) {
          var F = d.props;
          R.current.list.push({
            label: F.label,
            value: F.value,
            selected: F.isSelected,
            disabled: !!F.disabled
          }), F.isSelected || (c = !1);
        }
        return d;
      }
    });
    return at(c), Ae(["menu-header"].concat(zt(H, R.current.list, G))), l;
  }, [n]);
  ge(function() {
    oe(!1);
  }, []), ge(function() {
    Ae(["menu-header"].concat(zt(H, R.current.list, G)));
  }, [H]), ge(function() {
    if (Z != null && Z.current) {
      var c = document.getElementById("list-" + $), l = document.getElementById("list-container-" + $);
      c && (c == null ? void 0 : c.scrollHeight) > (c == null ? void 0 : c.clientHeight) ? l == null || l.classList.add("scroll") : l == null || l.classList.remove("scroll");
    }
  }, [n, $]);
  var it = St(
    function(c, l, d) {
      var F, P, xe;
      d === void 0 && (d = !1);
      var ue = R.current.callbacks, pe = ue.onChange, _ = ue.onBlur;
      if (!((c == null || (F = c.target) == null ? void 0 : F.tagName) === "INPUT" && (c == null || (P = c.target) == null ? void 0 : P.type) !== "radio" && (c == null || (xe = c.target) == null ? void 0 : xe.ariaLabel) !== w("Select All", "selectAll")))
        if (v === "multiple") {
          var ie = [];
          d ? R.current.list.forEach(function(Q) {
            l && ie.push({
              label: Q.label,
              value: Q.value,
              disabled: Q.disabled
            });
          }) : R.current.list.forEach(function(Q) {
            (Q.selected && Q.value !== l || !Q.selected && Q.value === l) && ie.push({
              label: Q.label,
              value: Q.value,
              disabled: Q.disabled
            });
          }), pe && (c.target.value = JSON.stringify(ie), pe(c, ie)), _ == null || _(c), C == null || C(c, l);
        } else {
          var me = [];
          R.current.list.forEach(function(Q) {
            Q.value === l && me.push({
              label: Q.label,
              value: Q.value
            });
          }), pe && (c.target.value = JSON.stringify(me == null ? void 0 : me[0]), pe(c, me == null ? void 0 : me[0])), _ == null || _(c), A && Ke(), C == null || C(c, l);
        }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  ), Ke = Ee.useCallback(function() {
    if (o && o(!1), Z.current && R.current.currentEle) {
      var c;
      R.current.currentEle = !1, (c = Z.current) == null || (c = c.querySelector("#control-" + a)) == null || c.focus();
    }
  }, []), ln = Je(function() {
    return {
      type: v,
      handleSelect: it
    };
  }, [it, v]), ht = function(l, d) {
    var F, P, xe, ue, pe;
    d === void 0 && (d = !1);
    var _ = Array.from((F = (P = fe.current) == null ? void 0 : P.querySelectorAll("li.list-item")) != null ? F : []), ie = (xe = fe.current) == null || (xe = xe.querySelectorAll("li.list-item:not([disabled])")) == null ? void 0 : xe.length, me = se === -1 ? 0 : se, Q = function(We) {
      var N, bt = fe == null || (N = fe.current) == null ? void 0 : N.querySelector(We);
      bt && (bt.setAttribute("data-value", "menu-header"), _ = [bt].concat(_));
    };
    !d && s === "local_search" && G.length === 0 ? Q(".list-item #local-search-" + $) : !d && s === "select_all" && Q(".list-item#select-all-" + $ + ' input[type="checkbox"]');
    var Ge = function() {
      if (l == null || l.preventDefault(), l == null || l.stopPropagation(), ie && _) {
        var We, N = se - 1;
        for (N < 0 && (N = _.length - 1), _[N] || (N = N - 1); (_[N].ariaDisabled !== "false" || !_e.includes(_[N].getAttribute("data-value"))) && (N = N - 1, N < 0 && (N = _.length - 1), me !== N); )
          ;
        (We = _[N]) == null || We.focus(), de(N);
      }
      return !1;
    }, pn = function() {
      if (l == null || l.preventDefault(), l == null || l.stopPropagation(), ie && _) {
        var We, N = se + 1;
        for (N >= _.length && (N = 0), _[N] || (N = N + 1); (_[N].ariaDisabled !== "false" || !_e.includes(_[N].getAttribute("data-value"))) && (N = N + 1, N >= _.length && (N = 0), me !== N); )
          ;
        (We = _[N]) == null || We.focus(), de(N);
      }
      return !1;
    };
    switch (l.code) {
      case Ya:
        Z == null || (ue = Z.current) == null || (ue = ue.querySelector("#control-" + $)) == null || ue.focus(), h && (l == null || l.stopPropagation(), l == null || l.preventDefault()), Ke();
        break;
      case "Enter":
      case "Space":
        if ((l == null || (pe = l.target) == null ? void 0 : pe.ariaLabel) === w("Select All", "selectAll"))
          return;
        It();
        break;
      case "ArrowUp":
        Ge();
        break;
      case "ArrowDown":
        pn();
        break;
      default:
        return;
    }
  }, sn = function() {
    if (v === "multiple")
      return "";
    for (var l = Ua(R.current.list), d; !(d = l()).done; ) {
      var F = d.value;
      if (F.selected && !F.disable)
        return "_" + xt(F.value);
    }
  }, dn = Je(function() {
    var c;
    return (H == null || (c = H.trim()) == null ? void 0 : c.length) > 0 || (_e == null ? void 0 : _e.length) <= 1;
  }, [H, _e]), It = function() {
    h ? Ke() : cn();
  }, cn = function() {
    de(-1), X(""), R.current.currentEle = !0, o && o(!0);
  };
  ge(function() {
    h && !Re && (ht({
      code: "ArrowDown",
      preventDefault: function() {
      },
      stopPropagation: function() {
      }
    }, !0), de(v === "multiple" && s === "select_all" || s === "local_search" ? 1 : 0));
    var c = function(d) {
      Z.current && !Z.current.contains(d.target) && h && (R.current.currentEle = !1, Ke());
    };
    return window.addEventListener("click", c), window.addEventListener("keyup", c), function() {
      window.removeEventListener("click", c), window.removeEventListener("keyup", c);
    };
  }, [h, Ke]);
  var ft = St(function(c, l, d) {
    d === void 0 && (d = !1);
    var F = window, P = F.innerWidth, xe = F.innerHeight, ue = ["auto", "up_auto", "down_auto"].includes(b), pe = Gt(b, ue), _ = Rt(he, fe, pe, "dropdown");
    if (ue) {
      var ie = parseFloat(_.top), me = parseFloat(_.left);
      if (b === "auto")
        if (ie < 0) {
          var Q;
          _ = Object.assign({}, _, {
            top: 8 + ((l == null ? void 0 : l.bottom) || c.height + ((Q = l == null ? void 0 : l.height) != null ? Q : 40)) + "px",
            transformOrigin: "top center"
          });
        } else
          ie + c.height > xe && (_ = Object.assign({}, _, {
            top: (l != null && l.top ? l == null ? void 0 : l.top : ie - 48) - c.height - (d ? 8 : 24) + "px",
            transformOrigin: "bottom center"
          }));
      var Ge = _.transformOrigin;
      b === "up_auto" ? Ge = "bottom center" : b === "down_auto" && (Ge = "top center"), me < 0 ? _ = Object.assign({}, _, {
        left: "8px",
        transformOrigin: Ge
      }) : me + c.width > P ? _ = Object.assign({}, _, {
        left: P - c.width - 8 + "px",
        transformOrigin: Ge
      }) : _ = Object.assign({}, _, {
        transformOrigin: Ge
      });
    }
    Xe(_);
  }, [b]);
  ge(function() {
    if (h && z) {
      var c = ["auto", "up_auto", "down_auto"].includes(b), l = Gt(b, c);
      Xe(Rt(he, fe, l, "dropdown"));
      var d = function() {
        var ue, pe, _, ie = (ue = he.current) == null ? void 0 : ue.querySelector('[data-trigger="true"]'), me = ie ? ie.getBoundingClientRect() : he == null || (pe = he.current) == null ? void 0 : pe.getBoundingClientRect();
        ft(fe == null || (_ = fe.current) == null ? void 0 : _.getBoundingClientRect(), me, !0);
      };
      window.addEventListener("scroll", d, !0);
      var F = function(ue) {
        window.requestAnimationFrame(function() {
          var pe, _, ie = (pe = he.current) == null ? void 0 : pe.querySelector('[data-trigger="true"]'), me = ie ? ie.getBoundingClientRect() : he == null || (_ = he.current) == null ? void 0 : _.getBoundingClientRect();
          ft(ue[0].contentRect, me);
        });
      }, P = new ResizeObserver(F);
      return P.observe(fe == null ? void 0 : fe.current), P.observe(he == null ? void 0 : he.current), function() {
        window.removeEventListener("scroll", d, !0), P.disconnect();
      };
    }
  }, [h, b, z, be, Me, ft]);
  var un = function() {
    if (s === "local_search" && G.length === 0)
      return /* @__PURE__ */ M(Bt, {
        children: [/* @__PURE__ */ r(Qn, {
          className: f(["DropdownBase-local-search", "list-item"]),
          children: /* @__PURE__ */ r(ct, {
            labelProp: {
              label: ""
            },
            id: "local-search-" + $,
            textSize: "medium",
            placeholder: w("Search...", "searchPlaceholder"),
            type: "search",
            "aria-label": w("Search...", "searchPlaceholder"),
            value: H,
            startAdornmentProp: {
              startAdornment: /* @__PURE__ */ r(je, {
                icon: "search"
              })
            },
            onChange: function(d) {
              X(d.currentTarget.value);
            },
            onKeyUp: function(d) {
              ["Escape", "ArrowUp", "ArrowDown"].includes(d == null ? void 0 : d.code) || (d == null || d.preventDefault(), d == null || d.stopPropagation());
            },
            accessibilityOptions: {
              ariaDisabled: !1
            }
          })
        }), /* @__PURE__ */ r(ut, {})]
      });
    if (v === "multiple" && s === "select_all")
      return /* @__PURE__ */ M(Bt, {
        children: [/* @__PURE__ */ r(ea, {
          className: f(["DropdownBase__select-all-wrapper", "list-item"]),
          onBlur: E,
          onClick: function(d) {
            d == null || d.preventDefault(), d == null || d.stopPropagation(), it(d, He ? "" : " ", !0);
          },
          onKeyDown: function(d) {
            ["Space", "Enter"].includes(d == null ? void 0 : d.code) && (it(d, He ? "" : " ", !0), d == null || d.preventDefault(), d == null || d.stopPropagation());
          },
          id: "select-all-" + $,
          children: /* @__PURE__ */ r("span", {
            className: "CheckBox-wrapper",
            style: {
              pointerEvents: "none"
            },
            children: /* @__PURE__ */ r(Ut, {
              tabIndex: -1,
              id: "select-all",
              label: w("Select All", "selectAll"),
              "aria-label": w("Select All", "selectAll"),
              "aria-disabled": !1,
              checkboxValue: He ? $e.CHECKED : $e.UNCHECKED
            }, "select-all")
          })
        }, "select-all-" + $), /* @__PURE__ */ r(ut, {})]
      });
  }, Nt = function() {
    var l = b;
    z || (b === "auto" || b === "down_auto" ? l = "down_left" : b === "up_auto" && (l = "up_left"));
    var d = z ? function(F) {
      F.stopPropagation();
    } : void 0;
    return /* @__PURE__ */ M(Xn, Object.assign({
      id: "content-" + $,
      onMouseDown: d,
      onClick: d,
      role: "region"
    }, Oe, {
      onKeyUp: function(P) {
        y || ht(P);
      },
      onKeyDown: function(P) {
        if (["ArrowUp", "ArrowDown"].includes(P.code))
          return P == null || P.preventDefault(), P == null || P.stopPropagation(), !1;
        z && P.code === "Tab" && (P.preventDefault(), P.stopPropagation(), Ke());
      },
      className: f(["DropdownBase__content-wrapper", "" + (z && "DropdownBase__content-wrapper--exceed"), {
        "DropdownBase__content-wrapper--menu-open": h
      }, "DropdownBase__content-wrapper-direction--" + l]),
      ref: fe,
      style: Object.assign({
        minWidth: ve
      }, z ? rt : {
        width: "max(" + ve + ", 100%)"
      }),
      "data-qm-block": U,
      "data-cs-mask": U,
      children: [un(), /* @__PURE__ */ r("div", {
        id: "list-container-" + $,
        onKeyDown: function(P) {
          P.code === "Space" && (P.preventDefault(), P.stopPropagation());
        },
        children: /* @__PURE__ */ M(Jn, Object.assign({
          $hiddenClasses: _e,
          $maxItems: D,
          id: "list-" + $,
          tabIndex: -1,
          className: f(["DropdownBase__Content-list", {
            "DropdownBase__Content-list--active": sn()
          }, {
            "DropdownBase__Content-list-searchable": dn
          }]),
          role: "listbox"
        }, rn, {
          children: [on, _e.length === 1 && /* @__PURE__ */ M(ta, {
            role: "option",
            className: "list-item",
            children: [w("No results found", "noResultText", T), /* @__PURE__ */ r(wn, {
              role: "alert",
              children: w("No results found", "noResultText", T)
            })]
          })]
        }))
      })]
    }));
  };
  return /* @__PURE__ */ r(tn.Provider, {
    value: ln,
    children: /* @__PURE__ */ M(Vn, Object.assign({
      ref: Z,
      className: f(["DropdownBase__wrapper", {
        "DropdownBase__wrapper--full-width": Y
      }, j]),
      "data-qm-block": U,
      "data-cs-mask": U
    }, q, x, {
      children: [/* @__PURE__ */ r(Yn, {
        ref: he,
        "aria-disabled": y,
        onKeyUp: function(l) {
          !y && ht(l);
        },
        onKeyDown: function(l) {
          if (l.code === "ArrowUp" || l.code === "ArrowDown")
            return l == null || l.preventDefault(), l == null || l.stopPropagation(), !1;
        },
        onClick: function(l) {
          l == null || l.preventDefault(), !(l.clientX === 0 && l.clientY === 0 && l.pageX === 0 && l.pageY === 0) && !y && It();
        },
        className: f(["DropdownBase__trigger-wrapper", {
          "DropdownBase__trigger-wrapper--disabled": y
        }]),
        id: "control-container-" + $,
        children: R.current.controlElement || kt
      }), !z && Nt(), !Ie && z && /* @__PURE__ */ gn(Nt(), document.body)]
    }))
  });
};
Ne.Control = Zn;
Ne.Item = yt;
Ne.Divider = ut;
Ne.Title = Vt;
var nn = /* @__PURE__ */ u.div.withConfig({
  displayName: "dropdownMenustyles__Control",
  componentId: "sc-1ul0n03-0"
})(["", ";"], function(t) {
  var e = t.theme.components.dropdownMenu;
  return p(e.Control);
}), Xa = function(e, n) {
  var a = e.trim();
  return a = a.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), n.filter(function(o) {
    return ("" + o.label + o.value).search(new RegExp(a, "i")) >= 0;
  }).map(function(o) {
    return o.value;
  });
}, an = function(e) {
  var n = Object.assign({}, (mt(e), e));
  return /* @__PURE__ */ r(yt, Object.assign({}, n));
}, nt = function(e) {
  var n = e.children, a = e.uniqueIdentifier, o = e.onChange, i = e.type, m = i === void 0 ? "default" : i, v = e.searchHandler, k = v === void 0 ? null : v, s = e.menuHeader, g = s === void 0 ? "default" : s, y = e.isDisabled, I = y === void 0 ? !1 : y, b = e.menuDirection, E = b === void 0 ? "down_left" : b, C = e.searchValue, T = C === void 0 ? "" : C, A = e.closeOnSelect, L = A === void 0 ? !1 : A, D = e.menuToggleSubscriber, h = e.loadDefaultOptions, j = h === void 0 ? 0 : h, K = e.onBlur, G = e.maxItems, B = G === void 0 ? 8 : G, z = e.className, J = e.exceedOverflow, re = J === void 0 ? !1 : J, ne = e.accessibilityOptions, Y = ne === void 0 ? {} : ne, W = e.menuWidth, ve = W === void 0 ? "280px" : W, ce = e.noResultText, Re = ye({
    label: "DropdownMenu"
  }), U = Ce(!1), x = U[0], q = U[1], ae = Ce(""), w = ae[0], O = ae[1], se = Ce([]), de = se[0], Z = se[1], R = Ce([]), ke = R[0], Ie = R[1], oe = we(ze("dd")), S = [], $ = !1, qe = Ee.Children.map(n, function(V, H) {
    if (V && /* @__PURE__ */ Ee.isValidElement(V)) {
      if (V.type === an) {
        var X = V.props;
        return S.push({
          value: X.value,
          label: X.label,
          description: X.description,
          key: X.value
        }), /* @__PURE__ */ r(Ne.Item, Object.assign({}, X, {
          isSelected: de.length > 0 ? de.map(function(Ae) {
            return Ae.value;
          }).includes(X == null ? void 0 : X.value) : (X == null ? void 0 : X.isSelected) || !1
        }), X.value);
      } else if (V.type === nn) {
        var Te = V.props;
        return Te != null && Te.render ? /* @__PURE__ */ r(Ne.Control, {
          children: Te == null ? void 0 : Te.render({
            id: "control-" + (a || oe.current),
            ariaControls: "list-" + (a || oe.current),
            ariaHasPopup: "listbox",
            ariaExpanded: x,
            ariaActivedescendant: ""
          })
        }, "control-" + oe.current) : /* @__PURE__ */ vn(Ne.Control, Object.assign({}, Te, {
          key: "control-" + oe.current
        }));
      } else if (V.type === ct) {
        var _e = V.props;
        return $ = !0, /* @__PURE__ */ r(Ne.Control, {
          children: /* @__PURE__ */ r(ct, Object.assign({}, _e, {
            id: "control-" + (a || oe.current),
            value: w,
            onChange: function(Le) {
              Le.stopPropagation(), O(Le.target.value), x || q(!0);
            }
          }))
        }, "control-" + oe.current);
      } else if (w.trim().length === 0)
        return /* @__PURE__ */ r(hn, {
          children: V
        }, "element-" + oe.current + "-" + H);
    }
  });
  ge(function() {
    if (D && D(x), x) {
      var V = S.some(function(X) {
        return X.label === w;
      });
      V && O("");
    } else {
      var H;
      O(m === "multiple" ? "" : ((H = de[0]) == null ? void 0 : H.label) || "");
    }
  }, [x]), ge(function() {
    T && O(T);
  }, [T]), ge(function() {
    O(T);
  }, [T]), ge(function() {
    var V = [];
    k ? V = k(w, S) : V = Xa(w, S), Ie(S.filter(function(H) {
      return !V.includes(H.value);
    }).map(function(H) {
      return H.value;
    }));
  }, [w]), ge(function() {
    j < 0 && q(!0), Z([]);
  }, [j]);
  var Fe = function(H, X) {
    H.stopPropagation(), o == null || o(H, X), Z(m === "multiple" ? X : [X]);
  };
  return /* @__PURE__ */ r(Ne, Object.assign({
    exceedOverflow: re,
    className: z,
    menuOpen: x,
    handleMenuOpen: function(H) {
      return q(H);
    },
    isDisabled: I,
    menuDirection: E,
    maxItems: B,
    uniqueIdentifier: a || oe.current,
    type: m,
    closeOnSelect: L,
    onBlur: K,
    onChange: Fe,
    hiddenItems: ke,
    menuWidth: ve,
    accessibilityOptions: Y,
    menuHeader: g && g !== "local_search" ? g : $ && "default" || "local_search",
    noResultText: ce,
    disableAutoFocus: $
  }, Re, {
    children: qe
  }));
};
nt.Control = nn;
nt.ControlInput = ct;
nt.Item = an;
nt.Divider = ut;
nt.Title = Vt;
export {
  Ut as C,
  nt as D,
  tt as L,
  te as M,
  pt as R,
  Zt as S,
  ct as T,
  Ne as _,
  $e as a,
  co as b,
  Oa as c,
  ja as d,
  Ve as e,
  Ze as f,
  Yt as g,
  pa as h,
  Pe as i,
  en as j,
  et as k,
  Se as l,
  Da as m
};
